import { render, staticRenderFns } from "./page-card-portrait.vue?vue&type=template&id=3b9aa384&scoped=true&"
import script from "./page-card-portrait.vue?vue&type=script&lang=js&"
export * from "./page-card-portrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9aa384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
